import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PermissionService } from 'src/app/utils/permission.service';
import { StateTypes } from '../../models/common';

@Component({
  selector: 'app-button-toggle-ui',
  templateUrl: './button-toggle-ui.component.html',
  styleUrls: ['./button-toggle-ui.component.css'],
})
export class ButtonToggleUiComponent {
  @Input() btnClass = 'w-[200px]';
  @Input() buttons: StateTypes[] = [];
  @Output() stateEmit: EventEmitter<StateTypes['value']> = new EventEmitter();

  constructor(private permissionsService: PermissionService) {}

  /** Identity for *ngFor: the value is what distinguishes a button. */
  public trackByValue(_index: number, button: StateTypes): string {
    return button.value;
  }

  public hasPermission(perms: string[]) {
    return this.permissionsService.hasPermissionList(perms);
  }
  toggleActive(val: StateTypes['value']) {
    this.buttons.forEach((button) => {
      button.isActive = button.value === val;
    });
    this.stateEmit.emit(val);
  }
}
